import React, { useId } from 'react';
import { formControlClass, formLabelClass } from './fieldStyles';

/**
 * Input (backward compatible). Extra optional props:
 * - leftIcon / rightIcon: ReactNode rendered inside the input
 * - hint: helper text shown below field (hidden when error is present)
 */
export const Input = ({
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}) => {
  const uid = useId().replace(/:/g, '');
  const { id: idFromProps, ...restProps } = props;
  const inputId = id ?? idFromProps ?? (label ? `fld-${uid}` : undefined);

  const paddingWithIcons = [
    leftIcon ? 'pl-10' : '',
    rightIcon ? 'pr-10' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className={formLabelClass}>
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center justify-center w-10 text-slate-400">
            {leftIcon}
          </span>
        )}
        <input
          id={inputId}
          className={formControlClass({ error: Boolean(error), className: `${paddingWithIcons} ${className}`.trim() })}
          aria-invalid={error ? true : undefined}
          {...restProps}
        />
        {rightIcon && (
          <span className="absolute inset-y-0 right-0 flex items-center justify-center w-10 text-slate-400">
            {rightIcon}
          </span>
        )}
      </div>
      {error ? (
        <p className="mt-1.5 text-sm text-rose-600 flex items-start gap-1" role="alert">
          <svg className="w-4 h-4 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
          </svg>
          <span>{error}</span>
        </p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
      ) : null}
    </div>
  );
};

export default Input;
